import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, query, updateDoc, where } from "firebase/firestore"
import { db } from "../Config/Firebase-config";

export const fetchCourseData = async () => {
    try {
        const querry = query(collection(db, "course"));
        const querySnapshot = await getDocs(querry);
        const courseList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        return courseList;
    } catch (error) {
        console.error("Error retrieving data: ", error.message);
    }
}

export const fetchAllSubjectData = async () => {
    try {
        const querry = query(collection(db, "subject"));
        const querySnapshot = await getDocs(querry);
        const courseList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        return courseList;
    } catch (error) {
        console.error("Error retrieving data: ", error.message);
    }
}

export const fetchSubjectData = async (course_code) => {
    try {
        const querry = query(collection(db, "subject"), where("course_code", "==", course_code));
        const querySnapshot = await getDocs(querry);
        const subjectList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        return subjectList;
    } catch (error) {
        console.error("Error retrieving data: ", error.message);
    }
}

export const fetchUnitData = async (subject_code) => {
    try {
        const querry = query(collection(db, "unit"), where("subject_code", "==", subject_code));
        const querySnapshot = await getDocs(querry);
        const unitList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        return unitList;
    } catch (error) {
        console.error("Error retrieving data: ", error.message);
    }
}

export const fetchTopicData = async (unit_code) => {
    try {
        const querry = query(collection(db, "topic"), where("unit_code", "==", unit_code));
        const querySnapshot = await getDocs(querry);
        const topicList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        return topicList;
    } catch (error) {
        console.error("Error retrieving data: ", error.message);
    }
}

export const fetchPdfData = async (pdf_code) => {
    if (!Array.isArray(pdf_code) || pdf_code.length === 0) {
        console.error("Error: pdf_code must be a non-empty array.");
        return [];
    }
    try {
        const queryRef = query(collection(db, "pdf"), where("pdf_code", "in", pdf_code));
        const querySnapshot = await getDocs(queryRef);
        const pdfList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        return pdfList;
    } catch (error) {
        console.error("Error retrieving data:", error.message);
        return [];
    }
};

export const fetchAudioData = async (audio_code) => {
    if (!Array.isArray(audio_code) || audio_code.length === 0) {
        console.error("Error: audio_code must be a non-empty array.");
        return [];
    }
    try {
        const queryRef = query(collection(db, "audio"), where("audio_code", "in", audio_code));
        const querySnapshot = await getDocs(queryRef);
        const audioList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        return audioList;
    } catch (error) {
        console.error("Error retrieving data:", error.message);
        return [];
    }
};

export const fetchVideoData = async (video_code) => {
    if (!Array.isArray(video_code) || video_code.length === 0) {
        console.error("Error: video_code must be a non-empty array.");
        return [];
    }
    try {
        const queryRef = query(collection(db, "video"), where("video_code", "in", video_code));
        const querySnapshot = await getDocs(queryRef);
        const videoList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data()
        }));
        return videoList;
    } catch (error) {
        console.error("Error retrieving data:", error.message);
        return [];
    }
}

export const fetchQuizData = async (quiz_code) => {
    if (!Array.isArray(quiz_code) || quiz_code.length === 0) {
        console.error("Error: video_code must be a non-empty array.");
        return [];
    }
    try {
        const queryRef = query(collection(db, "quiz"), where("quiz_code", "in", quiz_code));
        const querySnapshot = await getDocs(queryRef);
        const quizList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data()
        }));
        return quizList;
    } catch (error) {
        console.error("Error retrieving data:", error.message);
        return [];
    }
}

export const fetchQuizQuestionData = async (question_code) => {
    if (!Array.isArray(question_code) || question_code.length === 0) {
        console.error("Error: question_code must be a non-empty array.");
        return [];
    }

    const chunkSize = 30;
    const questionChunks = [];

    for (let i = 0; i < question_code.length; i += chunkSize) {
        questionChunks.push(question_code.slice(i, i + chunkSize));
    }

    try {
        const allQuestions = [];

        for (const chunk of questionChunks) {
            const queryRef = query(
                collection(db, "question"),
                where("question_code", "in", chunk)
            );
            const querySnapshot = await getDocs(queryRef);
            const questions = querySnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            allQuestions.push(...questions);
        }

        return allQuestions;
    } catch (error) {
        console.error("Error retrieving data:", error.message);
        return [];
    }
};

export const fetchEnrollCourses = async (UserDocId) => {
    try {
        const querry = query(collection(db, "enrolledCourses"), where("student_id", "==", UserDocId));
        const querySnapshot = await getDocs(querry);
        const enrolledData = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        return enrolledData;
    } catch (error) {
        console.error(error.message);
    }
}

export const fetchEnrollUnit = async (enroll_unit_code) => {
    if (!Array.isArray(enroll_unit_code) || enroll_unit_code.length === 0) {
        console.error("Error: enroll_unit_code must be a non-empty array.");
        return [];
    }
    try {
        const queryRef = query(collection(db, "unit"), where("unit_code", "in", enroll_unit_code));
        const querySnapshot = await getDocs(queryRef);
        const enroll_unit_List = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data()
        }));
        return enroll_unit_List;
    } catch (error) {
        console.error("Error retrieving data:", error.message);
        return [];
    }
}

export const saveCourseData = async (course) => {
    if (!Array.isArray(course)) {  // Ensure course is an object
        const docRef = await addDoc(collection(db, "enrolledCourses"), course);
        console.log("Document written with ID: ",docRef.id);
    } else {
        console.error("Error: Expected an object but received an array.");
    }
};


export const getEnrolledDocRef = async (userId) => {
    try {
        const enrolledRef = collection(db, "enrolledCourses"); 
        const q = query(enrolledRef, where("student_id", "==", userId));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            const docSnapshot = querySnapshot.docs[0];
            return doc(db, "enrolledCourses", docSnapshot.id);
        } else {
            console.log("No matching document found for student_id:", userId);
            return null;
        }
    } catch (error) {
        console.error("Error getting document reference:", error);
        return null;
    }
};

export const fetchResultData = async (quiz_code) => {
    try {
        const querry = query(collection(db, "results"),where("quiz_code","==",quiz_code));
        const querySnapshot = await getDocs(querry);
        const courseList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        return courseList;
    } catch (error) {
        console.error("Error retrieving data: ", error.message);
    }
}

export const upsertResultData = async (docId, quizCode, updatedData) => {
  try {
    const q = query(collection(db, "results"),where("student_id", "==", docId),where("quiz_code", "==", quizCode));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const existingDoc = querySnapshot.docs[0];
      const newAttempt = existingDoc.data().attempt_count+1;
      updatedData.attempt_count = newAttempt;
      const docRef = doc(db, "results", existingDoc.id);
      await updateDoc(docRef, updatedData);
      console.log("✔️ Existing result updated.");
    } else {
      await addDoc(collection(db, "results"), updatedData);
      console.log("🆕 New result created.");
    }
  } catch (error) {
    console.error("🔥 Error in upsertResultData:", error.message);
  }
};

export const getResultByStudentId = async (studentId,quiz_code) => {
  try {
    // const q = query(collection(db, "results"), where("student_id", "==", studentId));
    const q = query(
      collection(db, "results"),where("student_id", "==", studentId),where("quiz_code", "==", quiz_code) // added condition
    );
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      console.log("No student found with ID:", studentId);
      return null;
    }
    const doc = querySnapshot.docs[0];
    return { id: doc.id, ...doc.data() };

  } catch (error) {
    console.error("Error fetching result:", error);
    return null;
  }
};

// ---------------------------------------

// export const fetchData = async () => {
//     try {
//         const querySnapshot = await getDocs(collection(db, "question"));
//         const filteredQuestions = querySnapshot.docs
//             .map((doc) => ({
//                 id: doc.id,
//                 ...doc.data(),
//             }))
//             .filter((q) => q.hints && q.hints.trim() !== ""); // Only include questions with non-empty hints

//         return filteredQuestions;
//     } catch (error) {
//         console.error("Error retrieving data:", error.message);
//         return [];
//     }
// };

// export const fetchData2 = async (question_code) => {
//     try {
//         const querySnapshot = await getDocs(collection(db, "quiz"));
        
//         const filteredQuestions = querySnapshot.docs
//             .map((doc) => ({
//                 id: doc.id,
//                 ...doc.data(),
//             }))
//             .filter((question) => question.quizquestion_code_list && question.quizquestion_code_list.includes(question_code)); // Check if question_code exists in quizquestion_code_list

//         return filteredQuestions;
//     } catch (error) {
//         console.error("Error retrieving data:", error.message);
//         return [];
//     }
// };

// export const removeDuplicateResults = async () => {
//   try {
//     const snapshot = await getDocs(collection(db, "results"));
//     const studentMap = new Map();

//     // Step 1: Collect latest doc for each student_id
//     snapshot.docs.forEach((d) => {
//       const data = d.data();
//       const sid = data.student_id;
//       const existing = studentMap.get(sid);

//       if (!existing || data.timestamp > existing.data.timestamp) {
//         studentMap.set(sid, { id: d.id, data });
//       }
//     });

//     // Step 2: Delete all docs that are NOT the latest
//     for (let d of snapshot.docs) {
//       const data = d.data();
//       const sid = data.student_id;

//       if (studentMap.get(sid).id !== d.id) {
//         await deleteDoc(doc(db, "results", d.id));
//         console.log(`Deleted duplicate for student_id: ${sid}, docId: ${d.id}`);
//       }
//     }

//     console.log("✅ Duplicate cleanup completed!");
//   } catch (err) {
//     console.error("Error cleaning duplicates:", err);
//   }
// };